import { Component, computed, EventEmitter, Output } from "@angular/core";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RouterLink} from "@angular/router";
import {ButtonComponent as OldButton} from "../../base/button/button.component";
import {FormCardComponent} from "../../tablet/form-card/form-card.component";
import {FormGridComponent as OldFormGridComponent} from "../../layouts";
import {TextInputComponent} from "../../form-inputs";
import {LogoComponent} from "../../base/logo/logo.component";
import { getThemeConfig, RoutingNames } from "shared";
import { HeroComponent, HeroVariant, TopBarComponent } from "design-system-rijks";
import { AuthenticationConfig } from "shared";
import { NgTemplateOutlet } from "@angular/common";
import { ButtonComponent, FormGridComponent, IconComponent, InputComponent } from "design-system";


@Component({
  selector: 'lib-request-password-reset-form',
  standalone: true,
  imports: [
    ButtonComponent,
    FormCardComponent,
    OldFormGridComponent,
    OldButton,
    LogoComponent,
    ReactiveFormsModule,
    RouterLink,
    TextInputComponent,
    NgTemplateOutlet,
    HeroComponent,
    TopBarComponent,
    FormGridComponent,
    InputComponent,
    ButtonComponent,
    IconComponent,
  ],
  templateUrl: './request-password-reset-form.component.html',
  styleUrls: [
    '../login-form/login-form.component.scss',
    '../../tablet/form-card/form-card-form-wrapper.scss',
    '../otp-form/otp-form.component.scss',
  ],
})
export class RequestPasswordResetFormComponent {
  @Output() requestReset = new EventEmitter<string>();
  @Output() navigateBack = new EventEmitter<void>();
  // theming variables
  logoVariant!: HeroVariant;
  logoUrl = '';
  logoAltText = '';

  theme: AuthenticationConfig['theme'];

  formGroup: FormGroup;

  constructor(
    fb: FormBuilder,
    private config: AuthenticationConfig,
  ) {
    this.theme = config.theme;

    this.formGroup = fb.group({
      emailAddress: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.formGroup.valid) {
      const emailAddress = this.formGroup.value.emailAddress;
      this.requestReset.emit(emailAddress);
    }
  }

  onClickBackButton() {
    this.navigateBack.emit();
  }

  public useRijksVersion = computed(() => {
    const cfg = getThemeConfig(this.theme);
    if (cfg.logoVariant) this.logoVariant = cfg.logoVariant;
    this.logoUrl = cfg.logoUrl ?? '';
    this.logoAltText = cfg.logoAltText ?? '';
    return cfg.isRijksTheme;
  });
  protected readonly RoutingNames = RoutingNames;
}
